import App from './App';
import Home from './scenes/Home';
import About from './scenes/About';
import Contacts from './scenes/Contacts';
import Brief from './scenes/Brief';
import Jobs from './scenes/Jobs';
import Vacancy from './scenes/Vacancy';
import Approach from './scenes/Approach';
import NewsList from './scenes/NewsList';
import ProjectList from './scenes/CaseList';
import Case from './scenes/Case';
import NewsPost from './scenes/NewsPost';
import TermsOfUse from './scenes/TermsOfUse';
import PrivacyPolicy from './scenes/PrivacyPolicy';
import NotFound from './scenes/NotFound';

const routes = [
  {
    component: App,
    routes: [
      {
        path: '/',
        exact: true,
        component: Home,
      },
      {
        path: '/about',
        exact: true,
        component: About,
      },
      {
        path: '/contacts',
        exact: true,
        component: Contacts,
      },
      {
        path: '/brief',
        exact: true,
        component: Brief,
      },
      {
        path: '/jobs',
        exact: true,
        component: Jobs,
      },
      {
        path: '/jobs/:id',
        exact: true,
        component: Vacancy,
      },
      {
        path: '/approach',
        exact: true,
        component: Approach,
      },
      {
        path: '/news',
        exact: true,
        component: NewsList,
      },
      {
        path: '/news/:slug',
        exact: true,
        component: NewsPost,
      },
      {
        path: /^\/cases\/?(\?category=.*)?$/,
        // path: '/cases',
        exact: true,
        component: ProjectList,
      },
      {
        path: '/cases/:slug',
        exact: true,
        component: Case,
      },
      {
        path: '/terms-of-use',
        exact: true,
        component: TermsOfUse,
      },
      {
        path: '/privacy-policy',
        exact: true,
        component: PrivacyPolicy,
      },
      {
        exact: true,
        component: NotFound,
      },
    ],
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/routes.js